import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            热度排行
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            本周最受关注的吃瓜内容，热度实时更新
          </p>
        </div>

        <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
          {rankingData.map((item, i) => {
            const rankTag = item.rank <= 3
              ? 'bg-accent-500 text-background-50 dark:text-foreground-950'
              : 'bg-background-200 text-foreground-600';
            return (
              <a
                key={item.id}
                href="#cards"
                className={`flex items-center gap-4 px-4 md:px-6 py-4 hover:bg-background-100/60 transition-colors cursor-pointer ${
                  i < rankingData.length - 1 ? 'border-b border-background-200/50' : ''
                }`}
              >
                <span
                  className={`w-7 h-7 flex items-center justify-center rounded-lg text-xs font-bold shrink-0 ${rankTag}`}
                >
                  {item.rank}
                </span>
                <div className="flex-1 min-w-0">
                  <span className="text-sm md:text-base text-foreground-800 font-medium line-clamp-1">
                    {item.title}
                  </span>
                </div>
                <span className="inline-block px-2.5 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 whitespace-nowrap shrink-0">
                  {item.tag}
                </span>
                <span className="text-xs md:text-sm font-medium text-foreground-600 whitespace-nowrap shrink-0">
                  {item.heat}
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}